import React from 'react';
const FlagDisplay = ({ code, fallbackText }) => {
  // Map of language codes to emoji flags
  const flagEmojis = {
    'ma': '🇲🇦', 'darija': '🇲🇦',
    'en': '🇺🇸', 'es': '🇪🇸', 'fr': '🇫🇷', 
    'de': '🇩🇪', 'it': '🇮🇹', 'pt': '🇵🇹',
    'ar': '🇸🇦', 'tr': '🇹🇷', 'nl': '🇳🇱'
  };
  
  const flag = flagEmojis[code?.toLowerCase()] || '🌍';
  const text = fallbackText || code?.toUpperCase() || '??';
  
  return (
    <>
      <span className="flag-icon" role="img" aria-label={`${text} flag`}>
        {flag}
      </span>
      <span className="flag-text">{text}</span>
    </>
  );
};

// Maintenance Mode Page Component

export default FlagDisplay;
